import React, { useEffect } from 'react';
import styled from '@emotion/styled';
import { Magnetic as Mi } from "../../styles";
const vinInputWidth = 315;
export const VinValidator = props => {
    const vinRegex = /[\dabcdefghjklmnprstuvwxyz]{8}[x\d]{1}[\dabcdefghjklmnprstuvwxyz]{8}/i;
    const vinLength = 17;
    const vinInvalidChars = [
        73,
        105,
        79,
        111,
        81,
        113 // q
    ];
    const { id, className, disabled, onInvalidVin, onValidVin, onVinChanged, value } = props;
    useEffect(() => {
        if (value) {
            validateInput(value, onInvalidVin, onValidVin);
        }
    }, [value]);
    function validateInput(inputValue, onInvalidVin, onValidVin) {
        if (inputValue && inputValue.length === vinLength) {
            let isValidVin = vinRegex.test(inputValue);
            if (!isValidVin && onInvalidVin) {
                onInvalidVin(inputValue);
            }
            else if (isValidVin && onValidVin) {
                onValidVin(inputValue);
            }
        }
    }
    function onKeyPress(event) {
        let isValidChar = false;
        let isValidAlphabet = ((event.which >= 65 && event.which <= 90) || // upper case alphabets
            (event.which >= 97 && event.which <= 122)) && // lower case alphabets
            vinInvalidChars.indexOf(event.which) === -1; // invalid chars
        let isValidNum = event.which >= 48 && event.which <= 57; // digits
        isValidChar = isValidAlphabet || isValidNum;
        // the char at 9th place must be a digit or x or X.
        if (isValidChar && event.currentTarget.value.length === 8) {
            isValidChar = isValidNum || event.which === 88 || event.which === 120;
        }
        // prevent current character if it is invalid or Vin length has exceeded
        if (!isValidChar || length >= 17) {
            event.preventDefault();
        }
    }
    function handleChange(event) {
        if (onVinChanged) {
            onVinChanged(event.currentTarget.value);
        }
    }
    return (React.createElement("input", { spellCheck: false, type: "text", onChange: handleChange, onKeyPress: onKeyPress, value: value || '', id: id, className: className, disabled: disabled, maxLength: 17 }));
};
export const StyledVinValidator = styled(VinValidator) `
	background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAS8AAAAdCAYAAAD7G+rKAAAABGdBTUEAALGPC/xhBQAAAAlwSFlzAAAOwAAADsABataJCQAAABp0RVh0U29mdHdhcmUAUGFpbnQuTkVUIHYzLjUuMTAw9HKhAAAA5klEQVR4Xu3QMYrDQBBEUd//kJJiXWIMGy5FMQYHbfGCl9TAZ+jXWgvg58QRYLo4AkwXR4Dp4ggwXRwBposjwHRxBJgujgDTxRFgujgCTBdHgOniCDBdHAGmiyPAdHEEmC6OANPFEWC6OAJMF8dd932v4zj+/H/7hE6n0+l0T+3Ecdd1XV/5hE6n0+l0T+3Ecdd5nl/5hE6n0+l0T+3EcZfjdjqdTqfTxXGX43Y6nU6n08Vxl+N2Op1Op9PFcZfjdjqdTqfTxXGX43Y6nU6n08Vxl+N2Op1Op9PFcZfjdjqdTqfTrNcbvf/AscgXEKUAAAAASUVORK5CYII=');
	padding-left: 7px;
	background-repeat: no-repeat;
	background-position-y: 6px;
	background-position-x: 6px;
	text-transform: uppercase;
	font-family: 'Courier New', Courier, monospace;
	font-size: ${Mi.fontSize20};
	color: ${Mi.colorMocha06};
	width: ${vinInputWidth}px;
	letter-spacing: 6px; //separates the numbers so that they align with the tick marks
`;
//# sourceMappingURL=index.js.map